
import React, { useCallback } from 'react';

const AUDIO_URLS = {
  select: 'https://assets.mixkit.co/active_storage/sfx/2571/2571-preview.mp3',
  place: 'https://assets.mixkit.co/active_storage/sfx/2568/2568-preview.mp3',
  error: 'https://assets.mixkit.co/active_storage/sfx/2573/2573-preview.mp3',
  win: 'https://assets.mixkit.co/active_storage/sfx/2020/2020-preview.mp3',
  loss: 'https://assets.mixkit.co/active_storage/sfx/2019/2019-preview.mp3',
  rowComplete: 'https://assets.mixkit.co/active_storage/sfx/2017/2017-preview.mp3'
};

export const useSound = () => {
  const play = useCallback((type: keyof typeof AUDIO_URLS) => {
    const audio = new Audio(AUDIO_URLS[type]);
    audio.volume = 0.4;
    audio.play().catch(() => {});
  }, []);

  return { play };
};
